import ProductWillBeAddedSoon from "../ProductWillBeAddedSoon";

const SmartGadgetPage = () => {
  return <ProductWillBeAddedSoon />;
};

export default SmartGadgetPage;
